import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import { PageLayout } from '@/components/shared/PageLayout';

export function PermissionErrorPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageLayout contentClassName="max-w-4xl">
      <h1 className="page-title text-center">{t('admin.permissionError.title')}</h1>
      <div className="inline-flex flex-col space-y-4 w-full sm:w-fit self-center">
        <Button className="w-full" onClick={() => navigate('/')}>
          {t('admin.permissionError.backHome')}
        </Button>
      </div>
    </PageLayout>
  );
}
